import styles from './Menu.module.css';

export interface MenuOption<T extends string | number> {
  value: T;
  label: string;
}

/** Single-select list used inside a Popover. */
export function Menu<T extends string | number>({
  options,
  value,
  onSelect,
}: {
  options: MenuOption<T>[];
  value: T;
  onSelect: (value: T) => void;
}) {
  return (
    <div className={styles.menu} role="menu">
      {options.map((o) => (
        <button
          key={String(o.value)}
          type="button"
          role="menuitemradio"
          aria-checked={o.value === value}
          className={`${styles.item} ${o.value === value ? styles.active : ''}`}
          onClick={() => { onSelect(o.value); }}
        >
          {o.label}
          {o.value === value && <span className={styles.tick}>✓</span>}
        </button>
      ))}
    </div>
  );
}
